import React from 'react';
import { Check } from 'lucide-react';
import { ImageInfo } from './ImageInfo';

interface DraggableImageBoxProps {
  readonly url: string;
  readonly idx: number;
  readonly isSelected: boolean;
  readonly dimension?: string;
  readonly showCheckbox?: boolean;
  readonly align?: 'left' | 'center';
  readonly onClick?: () => void;
  readonly onDragStart?: (e: React.DragEvent) => void;
  readonly onToggleCheckbox?: () => void;
}

export const DraggableImageBox: React.FC<DraggableImageBoxProps> = ({
  url,
  idx,
  isSelected,
  dimension,
  showCheckbox = false,
  align = 'left',
  onClick,
  onDragStart,
  onToggleCheckbox,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
    <div
      draggable={showCheckbox ? isSelected : true}
      onDragStart={(e) => {
        if (showCheckbox && !isSelected) {
          return;
        }
        onDragStart?.(e);
      }}
      onClick={!showCheckbox ? onClick : undefined}
      style={{
        width: '100%',
        paddingBottom: '100%',
        position: 'relative',
        borderRadius: '6px',
        overflow: 'hidden',
        cursor: showCheckbox ? (isSelected ? 'grab' : 'default') : 'pointer',
        border: isSelected ? '3px solid #28a745' : '3px solid #dee2e6',
        transition: 'all 0.2s',
      }}
      onMouseOver={(e) => {
        if (!isSelected && !showCheckbox) {
          e.currentTarget.style.borderColor = '#0d6efd';
        }
      }}
      onMouseOut={(e) => {
        if (!isSelected && !showCheckbox) {
          e.currentTarget.style.borderColor = '#dee2e6';
        }
      }}
    >
      <img
        src={url}
        alt={`${showCheckbox ? 'Gallery' : 'Option'} ${idx + 1}`}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'contain' }}
      />
      {isSelected && !showCheckbox && (
        <div
          className="position-absolute top-0 end-0 m-1"
          style={{
            background: '#28a745',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Check size={14} color="white" />
        </div>
      )}
    </div>
    <ImageInfo url={url} {...(dimension && { dimension })} align={align} />
    {showCheckbox && (
      <div
        onClick={(e) => {
          e.stopPropagation();
          onToggleCheckbox?.();
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          width: '28px',
          height: '28px',
          borderRadius: '50%',
          border: '2px solid',
          borderColor: isSelected ? '#28a745' : '#dee2e6',
          background: isSelected ? '#28a745' : 'white',
          transition: 'all 0.2s',
        }}
      >
        <Check size={16} color={isSelected ? 'white' : '#dee2e6'} />
      </div>
    )}
  </div>
);
